import moment from "moment";
import { TimeOnly } from "typings/DateTime";

export const timeToDuration = (time: TimeOnly, unitOfDuraition: moment.unitOfTime.Base): number => {
    return moment.duration(time).as(unitOfDuraition);
}
